import React from "react"

import AllAccessCategories from "components/custom/all-access/categories"
import HomePageInstitute from "components/custom/home/institute"
import HomePageBrandCarousel from "components/custom/home/brand-carousel"

const ContentfulCustomCodedBlock = ({ component }) => {
  switch (component.blockCodeIdentifier) {
    case "all-access-categories":
      return <AllAccessCategories />
    case "home-page-institute":
      return <HomePageInstitute />
    case "home-page-brand-carousel":
      return <HomePageBrandCarousel />
    default:
      return null
  }
}

export default ContentfulCustomCodedBlock
